import { defineStore } from 'pinia';
import axios from 'axios';

export const useRequisitionProductStore = defineStore('requisitionProduct', {
  state: () => ({
    requisitionProductItems: []
  }),

  actions: {
    UPDATE_REQUISITION_PRODUCT_ITEMS(payload) {
      this.requisitionProductItems = payload;
    },
    REMOVE_ALL_REQUISITION_PRODUCT() {
      this.requisitionProductItems = [];
    },
    getRequisitionProductItems(paramData) {
      axios.get(paramData.url + '/requisition_products', paramData.header).then((response) => {
        this.UPDATE_REQUISITION_PRODUCT_ITEMS(response.data.data);
      });
    },
    removeAllRequitionProduct() {
      this.REMOVE_ALL_REQUISITION_PRODUCT();
    }
  }
});
